export const getImportList = state => state.import.importData;
export const getPagination = state => state.import.pagination;
export const getSelected = state => state.import.selected;
export const getIsLoading = state => state.import.isLoading;
export const getProgressingFiles = state => state.import.progressingFiles;
